module.exports = __webpack_public_path__ + "static/img/dentaltalk_sm_landscape.c9ebf98.png";


//////////////////
// WEBPACK FOOTER
// ./src/art/dentaltalk_sm_landscape.png
// module id = oN14
// module chunks = 1